import { STORAGE_KEYS } from "./config";
import { local } from "./storage";
import { uuid } from "./uuid";

/**
 * Stable anonymous id, generated on first visit (before any login) and
 * persisted forever. Never regenerated once it exists. Sent on every `/track`
 * call and on the signup/login request so the backend can stitch prior
 * anonymous events to the user.
 */
export const getAnonymousId = (): string => {
  const existing = local.get(STORAGE_KEYS.anonymousId);
  if (existing) return existing;

  const fresh = `anon_${uuid()}`;
  local.set(STORAGE_KEYS.anonymousId, fresh);
  return fresh;
};

/** mobile | desktop — coarse classification the backend expects. */
export const getDeviceType = (): "mobile" | "desktop" => {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  return /Mobi|Android|iPhone|iPad|iPod|Eitaa/i.test(ua) ? "mobile" : "desktop";
};

/** Best-effort OS name for `session_started`. */
export const getOs = (): string => {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
  if (/Windows/i.test(ua)) return "Windows";
  if (/Mac OS X/i.test(ua)) return "macOS";
  if (/Linux/i.test(ua)) return "Linux";
  return "unknown";
};

/** Best-effort browser name for `session_started`. */
export const getBrowser = (): string => {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/Edg\//i.test(ua)) return "Edge";
  if (/OPR\/|Opera/i.test(ua)) return "Opera";
  if (/Chrome\//i.test(ua)) return "Chrome";
  if (/Firefox\//i.test(ua)) return "Firefox";
  if (/Safari\//i.test(ua)) return "Safari";
  return "unknown";
};
